module.exports = __webpack_public_path__ + "img/header-with-logo-min.72bd420e.jpg";